import React from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// import required modules
import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules';

import { Hero, Features, CTA } from "@/components/features/home";
import { MetaNetHero } from "@/components/features/metanet";

// Newsfeed data with titles, image URLs, and dates
const newsItems = [
  {
    url: 'https://coingeek.com/bitcoin-babbage-bbq-sights-and-sounds-from-austin-bsv-hackathon/',
    type: 'Article',
    title: 'Bitcoin, Babbage, BBQ: Sights and Sounds from Austin BSV Hackathon',
    imageUrl: 'https://coingeek.com/wp-content/uploads/2025/04/BSV-Hackathon-Texas.webp',
    date: 'April 8th, 2024'
  },
  {
    url: 'https://coingeek.com/ty-everett-examines-babbage-software-stack-for-bsv-hackathon/',
    type: 'Article',
    title: 'Ty Everett examines Babbage software stack for BSV Hackathon',
    imageUrl: 'https://coingeek.com/wp-content/uploads/2025/03/Hackathon.webp',
    date: 'March 2024' // Guessed based on context
  },
  {
    url: 'https://www.youtube.com/live/P0s-uwDH990',
    type: 'Video',
    title: 'BSV Association - Texas Hackathon Livestream',
    imageUrl: 'https://img.youtube.com/vi/P0s-uwDH990/hqdefault.jpg',
    date: 'March 2024' // Guessed based on context
  },
  {
    url: 'https://coingeek.com/ty-everett-lays-out-what-to-expect-on-texas-bsv-hackathon-video/',
    type: 'Article',
    title: 'Ty Everett lays out what to expect on Texas BSV Hackathon [Video]',
    imageUrl: 'https://coingeek.com/wp-content/uploads/2025/03/Ty-Everett.webp',
    date: 'March 2024' // Guessed based on context
  },
  {
    url: 'https://coingeek.com/project-babbage-demonstrates-interoperable-solutions/',
    type: 'Article',
    title: 'Project Babbage demonstrates interoperable solutions',
    imageUrl: 'https://coingeek.com/wp-content/uploads/2024/05/FI_FINAL-jpg.webp',
    date: 'May 2024' // From URL
  },
  {
    url: 'https://coingeek.com/babbage-set-to-release-new-software-stack-for-bsv-hackathon/',
    type: 'Article',
    title: 'Babbage set to release new software stack for BSV Hackathon',
    imageUrl: 'https://coingeek.com/wp-content/uploads/2025/03/BSV-Hackathon-Texas-Hackathon-2025.webp',
    date: 'March 2024' // Guessed based on context
  },
  {
    url: 'https://www.youtube.com/watch?v=YRHvKQ0rJ3w',
    type: 'Video',
    title: 'The Arc: Bitcoin Transaction Processor explained',
    imageUrl: 'https://img.youtube.com/vi/YRHvKQ0rJ3w/hqdefault.jpg',
    date: 'July 2024' // Guessed recent date
  },
  {
    url: 'https://coingeek.com/what-does-the-future-of-internet-look-like-project-babbage-cto-answers-on-coingeek-weekly-livestream-video/',
    type: 'Article',
    title: 'Future of Internet? Project Babbage CTO Answers [Video]',
    imageUrl: 'https://coingeek.com/wp-content/uploads/2024/05/Brayden-CG-jpg.webp',
    date: 'May 2024' // From URL
  },
  {
    url: 'https://coingeek.com/overlays-will-provide-a-service-layer-for-information-in-the-teranode-era/',
    type: 'Article',
    title: 'Overlays will provide a service layer for information in the Teranode era',
    imageUrl: 'https://coingeek.com/wp-content/uploads/2024/03/Bitcoin--jpg.webp',
    date: 'March 2024' // From URL
  },
  {
    url: 'https://coingeek.com/universal-digital-ids-developing-new-mobile-os-likely-needed/',
    type: 'Article',
    title: 'Universal Digital IDs: Developing new mobile OS likely needed',
    imageUrl: 'https://coingeek.com/wp-content/uploads/2024/07/Universal-Digital-IDs.webp',
    date: 'July 2024' // From URL
  }
];

const Index: React.FC = () => {
  return (
    <div className="min-h-screen">
      <Hero />
      {/* <MetaNetHero /> */}

      {/* Newsfeed Slider Section */}
      <section className="mb-12 container mx-auto px-4 py-8 relative">
        <h2 className="text-2xl font-semibold mb-6">Latest News & Videos</h2>
        <div className="relative group">
          <style>
            {`
              .swiper-pagination-bullet {
                background: #9ca3af !important;
                opacity: 0.5;
                width: 8px !important;
                height: 8px !important;
              }
              .swiper-pagination-bullet-active {
                background: #6b7280 !important;
                opacity: 1;
              }
              .dark .swiper-pagination-bullet {
                background: #d1d5db !important;
              }
              .dark .swiper-pagination-bullet-active {
                background: #e5e7eb !important;
              }
              .swiper-pagination {
                position: relative !important;
              }
            `}
          </style>
          <Swiper
            cssMode={true}
            navigation={{
              prevEl: '.swiper-button-prev-custom',
              nextEl: '.swiper-button-next-custom',
            }}
            pagination={{
              clickable: true,
              bulletActiveClass: 'swiper-pagination-bullet-active'
            }}
            mousewheel={true}
            keyboard={true}
            modules={[Navigation, Pagination, Mousewheel, Keyboard]}
            className="mySwiper w-full mb-8"
            spaceBetween={30}
            slidesPerView={1}
            breakpoints={{
              640: {
                slidesPerView: 2,
                spaceBetween: 30
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 40
              }
            }}
          >
            {newsItems.map((item, index) => (
              <SwiperSlide key={index} className="flex pb-16">
                <a
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block h-full w-full bg-card border border-border rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 overflow-hidden flex flex-col group"
                  aria-label={`Link to ${item.title}`}
                >
                  <div className="w-full h-40 overflow-hidden">
                    <img
                      src={item.imageUrl}
                      alt={`Image for ${item.title}`}
                      className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                    />
                  </div>
                  <div className="p-4 flex-grow flex flex-col justify-between">
                    <div>
                      <span className="text-base font-semibold text-card-foreground group-hover:text-primary transition-colors duration-300 line-clamp-3 mb-2 block">
                        {item.title}
                      </span>
                    </div>
                    <p className="text-xs text-muted-foreground mt-1">
                      {item.date}
                    </p>
                  </div>
                </a>
              </SwiperSlide>
            ))}
          </Swiper>
          {/* Custom navigation buttons */}
          <button className="swiper-button-prev-custom absolute left-0 top-1/2 transform -translate-y-1/2 z-10 bg-white dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 shadow-lg rounded-r-lg p-3 transition-all duration-200 opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-6 h-6 text-gray-800 dark:text-gray-200">
              <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
            </svg>
          </button>
          <button className="swiper-button-next-custom absolute right-0 top-1/2 transform -translate-y-1/2 z-10 bg-white dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 shadow-lg rounded-l-lg p-3 transition-all duration-200 opacity-0 group-hover:opacity-100 translate-x-2 group-hover:translate-x-0">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-6 h-6 text-gray-800 dark:text-gray-200">
              <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
            </svg>
          </button>
        </div>
      </section>

      <Features />
      <CTA />
    </div>
  );
};

export default Index;
